import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles, Typography } from '@material-ui/core';

const useStyle = makeStyles((theme) => {
  return {
    listItem: {
      cursor: 'pointer',
      width: 'max-content',
    },
    list: {
      marginBottom: 40,
    },
    activeItem: {
      fontWeight: 600,
      fontSize: 14,
    },
    header: {
      fontWeight: 600,
      fontSize: 13,
      color: theme.text.item,
      marginTop: 16,
    },
    item: {
      fontSize: 14,
    },
  };
});

export const SettingSidebar = ({ menuItems }) => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyle();

  const MenuItem = ({ item }) => (
    <ListItem
      key={item.text}
      onClick={() => {
        history.push(item.path);
      }}
      className={classes.listItem}
    >
      <ListItemText
        disableTypography
        className={classes.listItem}
        primary={
          <Typography
            className={
              location.pathname === item.path
                ? classes.activeItem
                : classes.item
            }
          >
            {item.text}
          </Typography>
        }
      />
    </ListItem>
  );

  return (
    <List className={classes.list} dense>
      <ListItem>
        <ListItemText
          disableTypography
          primary={<Typography className={classes.header}>PROFILE</Typography>}
        />
      </ListItem>

      {menuItems.profile.map((item, index) => (
        <MenuItem item={item} key={index} />
      ))}

      <ListItem>
        <ListItemText
          disableTypography
          primary={
            <Typography className={classes.header}>
              MEETING PREFERENCES
            </Typography>
          }
        />
      </ListItem>

      {menuItems.preferences.map((item, index) => (
        <MenuItem item={item} key={index} />
      ))}

      <ListItem>
        <ListItemText
          disableTypography
          primary={<Typography className={classes.header}>SECURITY</Typography>}
        />
      </ListItem>

      {menuItems.security.map((item, index) => (
        <MenuItem item={item} key={index} />
      ))}
    </List>
  );
};
